import { getPathAdAccountId } from '../../utils'
import { useMemo } from 'react'

const ServiceLink = () => {
  const adAccountId = getPathAdAccountId()
  const href = useMemo(
    () => (adAccountId ? `/${adAccountId}/dashboard` : '/adaccount/all'),
    [adAccountId]
  )
  return (
    <a href={href} className="tit_service">
      <img
        src="//t1.kakaocdn.net/biz/ui/keywordad/logo_keywordad.png"
        className="thumb_service"
        alt="키워드광고 관리자센터"
      />
    </a>
  )
}
export default ServiceLink
